import { render } from "./Szja.vue?vue&type=template&id=649d3175"
import script from "./Szja.vue?vue&type=script&lang=js"
export * from "./Szja.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/aldasforras_vue/aldasforras_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__